import { AxiosError } from 'axios'
import { LuigiClient } from './base-clients/luigi'
import { ok, err, Result } from 'neverthrow'

export const getSignedURLSApi = async (path: string): Promise<Result<string, AxiosError>> => {
    try {
        const resp = await LuigiClient.post(
            `api/v1/signed-urls`,
            {
                paths: [
                    {
                        path,
                        expiry: 86400,
                    },
                ],
            },
            {
                headers: {
                    'x-vault-key': 'fts-data',
                },
            }
        )
        return ok(resp.data.data[path].download_url)
    } catch (e) {
        return err(e as AxiosError)
    }
}
